import { render, staticRenderFns } from "./model_list.vue?vue&type=template&id=6b2f3a3c&scoped=true"
import script from "./model_list.vue?vue&type=script&lang=js"
export * from "./model_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f3a3c",
  null
  
)

export default component.exports